import React, { useMemo, useState } from 'react';
import CompanyTable from './CompanyTable';
import CreateCompanyModal from '../create-company/create-company-modal';
import useCompanies from '../../../hooks/useCompanies';
import useContacts from '../../../hooks/useContacts';
import SearchHeader from '../../../components/search-header/search-header';
import { useAuth } from '../../../context/AuthContext';
import { generateCompaniesCSV } from './csv/comapies-cvs';

function CompanyModal() {
  const { userPermissions } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [nextId, setNextId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const { companies, refetch } = useCompanies();
  const { contacts } = useContacts();

  const companiesWithPrimaryContacts = useMemo(() => {
    if (!companies || !contacts) return [];

    // Map contacts by companyID for quick lookup
    const contactsMap = contacts.reduce((map, contact) => {
      if (contact.companyID && contact.type === 'Primary') {
        map[contact.companyID] = contact;
      }
      return map;
    }, {});

    return companies.map((company) => {
      const primaryContact = contactsMap[company.companyID];
      return {
        ...company,
        primaryContactName: primaryContact
          ? `${primaryContact.firstName} ${primaryContact.lastName}`
          : null,
        primaryContactEmail: primaryContact?.emailAddress || null,
        primaryContactPhone: primaryContact?.phoneNumber || null,
        primaryContactId: primaryContact?.id || null,
      };
    });
  }, [companies, contacts]);

  const handleSearch = (query) => {
    console.log('Search Query:', query);
    setSearchQuery(query);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const showHeaderCta =
    userPermissions === 'Admin' ||
    userPermissions === 'Project Manager' ||
    userPermissions === 'Supervisor';

  return (
    <div className="company-container">
      <SearchHeader
        placeholder={'Search a keyword, client or contact.'}
        heading={'Companies'}
        ctaTitle={showHeaderCta ? 'Add Company' : ''}
        ctaHandler={() => setShowModal(true)}
        handleSearch={handleSearch}
        optionsList={[
          {
            title: 'Export List CSV',
            onClick: () => generateCompaniesCSV(companiesWithPrimaryContacts),
          },
        ]}
      />
      {companies && (
        <CompanyTable
          companies={companiesWithPrimaryContacts}
          searchQuery={searchQuery}
          handleShowModal={handleShowModal}
        />
      )}

      {showModal && (
        <CreateCompanyModal
          nextId={nextId}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            refetch(); // Refetch companies to update the list
            setShowModal(false);
          }}
          isConfirming={false}
        />
      )}
    </div>
  );
}

export default CompanyModal;
